import { querySelector } from '../functions/querySelectors';
import { DEFAULT_TRANSITION_TIME } from '../config/main';

const LOADER_CLASS = 'l-loader';
const LOADER_SHOW_CLASS = 'l-loader--show';

let getLoader = function() {
  return querySelector(`.${LOADER_CLASS}`);
};

let show = function() {
  getLoader().classList.add(LOADER_SHOW_CLASS);
};

let hide = function() {
  let loader = getLoader();

  loader.style.opacity = 0;

  setTimeout(function() {
    loader.classList.remove(LOADER_SHOW_CLASS);
    loader.style.removeProperty('opacity');
  }, DEFAULT_TRANSITION_TIME);
};

export default {
  show: show,
  hide: hide
};
